export default __webpack_public_path__ + "media/images/manual/joanr/02-67dad656a4c2718197a5123d9e64e61b.png";